export const GETSUPPLIERCOUNT = 'GETSUPPLIERCOUNT'
export const GETUNPAIDBILLINONEYEAR = 'GETUNPAIDBILLINONEYEAR'
export const GETBILLTOTALMONEYRANKING = 'GETBILLTOTALMONEYRANKING'
export const GETHEADTIP = 'GETHEADTIP'
export const GETNOWEXTSKUTASK = 'GETNOWEXTSKUTASK'
export const GETMAXSOLD = 'GETMAXSOLD'
export const GETSAASHOMEPAGETOP = 'GETSAASHOMEPAGETOP'
export const GETSAASHOMEPAGEBELOW = 'GETSAASHOMEPAGEBELOW'



// WEBPACK FOOTER //
// ./src/store/home/types.js